import React from 'react';
import { Alert, Button } from '@mui/material';

/** Asks for the deployment schedule workbook and jumps to the Plan vs actual tab, where it is uploaded. */
const PlanPrompt = ({ onOpenPlans, severity = 'info', children, sx }) => (
  <Alert
    severity={severity}
    sx={sx}
    action={onOpenPlans ? (
      <Button color="inherit" size="small" onClick={onOpenPlans} sx={{ textTransform: 'none', fontWeight: 600, whiteSpace: 'nowrap' }}>
        Upload deployment schedule
      </Button>
    ) : null}
  >
    {children}
  </Alert>
);

export default PlanPrompt;
